import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DarkModeIcon, LightModeIcon, SystemModeIcon } from './icons';
import { useTranslation } from 'react-i18next';
import { useThemeMode } from '@/context/theme-mode-context';
import type { ThemeModePreference } from '@/context/theme-mode-context';

const OPTIONS: ReadonlyArray<{ value: ThemeModePreference; Icon: typeof LightModeIcon }> = [
  { value: 'light', Icon: LightModeIcon },
  { value: 'dark', Icon: DarkModeIcon },
  { value: 'system', Icon: SystemModeIcon },
];

/** Light / Dark / System selector; the choice persists (see ThemeModeProvider). */
export function ThemeModeSelect({ fullWidth = false }: { fullWidth?: boolean }) {
  const { t } = useTranslation();
  const { themeMode, setThemeMode } = useThemeMode();

  return (
    <ToggleButtonGroup
      value={themeMode}
      exclusive
      fullWidth={fullWidth}
      size="small"
      color="standard"
      aria-label={t('theme.label')}
      onChange={(_event, next: ThemeModePreference | null) => {
        if (next) setThemeMode(next);
      }}
    >
      {OPTIONS.map(({ value, Icon }) => (
        <ToggleButton key={value} value={value} aria-label={t(`theme.${value}`)}>
          <Icon size={20} />
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
